<div class="circle-btn" (click)="disabled ? disabledAreaClick($event) : null">
  <div
    class="icon-container"
    [class.blue]="color === 'blue'"
    [class.yellow]="color === 'yellow'"
    [class.light-grey]="color === 'light-grey'"
    [class.white-blue]="color === 'white-blue'"
    [class.grey]="color === 'grey'"
    [class.red]="color === 'red'"
    [class.disabled]="disabled">
    <fa-icon *ngIf="faIcon && !loading" [icon]="faIcon" [size]="faSize"></fa-icon>

    <div *ngIf="loading" class="sk-fading-circle">
      <div class="sk-circle1 sk-circle"></div>
      <div class="sk-circle2 sk-circle"></div>
      <div class="sk-circle3 sk-circle"></div>
      <div class="sk-circle4 sk-circle"></div>
      <div class="sk-circle5 sk-circle"></div>
      <div class="sk-circle6 sk-circle"></div>
      <div class="sk-circle7 sk-circle"></div>
      <div class="sk-circle8 sk-circle"></div>
      <div class="sk-circle9 sk-circle"></div>
      <div class="sk-circle10 sk-circle"></div>
      <div class="sk-circle11 sk-circle"></div>
      <div class="sk-circle12 sk-circle"></div>
    </div>
  </div>
  @if (label) {
    <span class="label" [innerHtml]="label"></span>
  }
</div>
